import {
  HttpClient,
  HttpContext,
  HttpHeaders,
  HttpParams
} from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { HappyTenantContextService } from './happy-tenant-context.service';
import { SKIP_STORE_API_KEY } from '../../interceptors/http-context-tokens';

export type HappyStoreStatus = 'active' | 'inactive';
export type HappyStoreType = 'instant_ordering' | 'subscription_ordering';

export interface HappyApiStore {
  id: number;
  name: string;
  domain: string;
  type: HappyStoreType;
  status: HappyStoreStatus;
  api_key: string;
}

interface StoresListResponse {
  status: boolean;
  message: string;
  data: HappyApiStore[];
}

@Injectable({ providedIn: 'root' })
export class HappyStoresApiService {
  private readonly http = inject(HttpClient);
  private readonly tenantContext = inject(HappyTenantContextService);

  fetchStores(): Observable<HappyApiStore[]> {
    const baseUrl: string = (environment as any).happyApi?.baseUrl || '';
    const url = `${baseUrl}/stores/list`;

    const tenant = this.tenantContext.tenant();
    const headers = new HttpHeaders({
      Accept: 'application/json'
    });
    const params = new HttpParams().set('tenant', tenant);

    const context = new HttpContext().set(SKIP_STORE_API_KEY, true);

    return this.http
      .get<StoresListResponse>(url, { headers, params, context })
      .pipe(map((response) => response.data ?? []));
  }

  fetchActiveInstantOrderingStores(): Observable<HappyApiStore[]> {
    return this.fetchStores().pipe(
      map((stores) =>
        stores.filter(
          (s) => s.type === 'instant_ordering' && s.status === 'active'
        )
      )
    );
  }
}
